import { render, staticRenderFns } from "./weight-note.vue?vue&type=template&id=1ee36fea&scoped=true&"
import script from "./weight-note.vue?vue&type=script&lang=js&"
export * from "./weight-note.vue?vue&type=script&lang=js&"
import style0 from "./weight-note.vue?vue&type=style&index=0&id=1ee36fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee36fea",
  null
  
)

export default component.exports